import { QueryKey, useQueryClient } from "@tanstack/react-query";

import { useSubscription } from "../useGraphQlClient";

type Props<TData> = {
  /** The printed subscription document; it takes a single `operationId` variable. */
  subscription: string;
  operationId: string | null;
  enabled: boolean;
  /** The cached query to re-read once the run ends; it stays the source of truth. */
  queryKey: QueryKey;
  getStatus: (data: TData) => string;
};

/** Re-reads a document AI run's cached query when its live status reaches a terminal state. */
export function useDocumentAiRunUpdates<TData>({
  subscription,
  operationId,
  enabled,
  queryKey,
  getStatus,
}: Props<TData>) {
  const queryClient = useQueryClient();

  return useSubscription<TData, { operationId: string }>(
    subscription,
    { operationId: operationId ?? "" },
    {
      enabled: enabled && !!operationId,
      onData: (data) => {
        const status = getStatus(data);
        if (status === "completed" || status === "failed") {
          void queryClient.invalidateQueries({ queryKey });
        }
      },
    },
  );
}
